import { Location } from '@angular/common';
import { Component, Input, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { RouteTrackerState } from '@core/helper/route-tracker.helper';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-back-button',
    templateUrl: './back-button.component.html',
    standalone: false
})
export class BackButtonComponent implements OnDestroy {

  @Input() backRouterLink: string | undefined = undefined;

  public showBackButton$ = RouteTrackerState.showBackButton$;
  public subs = new Subscription();

  constructor(private location: Location, private router: Router) {
    const sub = RouteTrackerState.goBack$.subscribe(() => {
      this.goBack();
    });
    this.subs.add(sub);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  goBack() {
    if (this.backRouterLink) {
      this.router.navigateByUrl(this.backRouterLink);
    } else {
      this.location.back();
    }
  }
}


